import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import { Subscription } from '@app/store/transport-layer/subscription/subscription';

export type ResumeSubscriptionResponse = Subscription;
export function resumeSubscriptionAPI(workspaceId: string) {
  return requestApi<ResumeSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/subscribe`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
